/**
 * Raisons d'un refus ou d'une annulation d'envoi telles que le serveur les écrit (`sms_outbox.reason`), en
 * français. Source unique pour le journal et le résultat d'un SMS test.
 */
const reasonLabels: Record<string, string> = {
  NO_CONSENT: 'aucune preuve de consentement pour ce numéro et cette portée',
  LOCAL_BLOCK: 'numéro bloqué (STOP ou retrait)',
  PROVIDER_OPTED_OUT: 'numéro désinscrit chez Telnyx (STOP)',
  SENDING_PAUSED: 'nouveaux envois suspendus',
  DAILY_CAP_REACHED: 'plafond quotidien atteint',
  NOT_IN_TEST_ALLOWLIST: 'numéro hors de la liste des numéros d’équipe (mode pilote)',
  MODULE_DISABLED: 'module désactivé',
  UNKNOWN_CONTACT: 'numéro inconnu',
  NO_RECENT_INBOUND: 'aucun message récent du client auquel répondre',
  NO_OPEN_CONSENT_REQUEST: 'aucune demande d’inscription ouverte',
  TEMPLATE_NOT_FOUND: 'modèle introuvable',
  TEMPLATE_INACTIVE: 'modèle inactif',
  TEMPLATE_SCOPE_MISMATCH: 'modèle prévu pour une autre portée',
  SMS_TEMPLATE_UNKNOWN_VARIABLE: 'variable non autorisée dans le modèle',
  SMS_TEMPLATE_MISSING_VALUE: 'valeur manquante pour une variable du modèle',
  SHARED_NUMBER: 'numéro partagé entre plusieurs dossiers',
  UNCONFIRMED_NUMBER: 'association du numéro au dossier non confirmée',
  INVALID_NUMBER: 'numéro invalide',
  LANDLINE: 'ligne fixe : ce numéro ne reçoit pas de SMS',
  EXPIRED: 'délai de validité dépassé avant l’envoi',
  CONSENT_WITHDRAWN: 'consentement retiré avant l’envoi',
  OPTED_OUT: 'destinataire désinscrit avant l’envoi',
  TO_RECONCILE: 'résultat de la soumission inconnu',
  RETRY: 'nouvel essai prévu après un échec temporaire',
  PROVIDER_40300: 'destinataire désinscrit chez Telnyx (STOP)',
  PROVIDER_ERROR: 'erreur du fournisseur',
}

/** Raison lisible ; un code inconnu reste affiché tel quel plutôt que masqué. */
export function reasonLabel(reason: string | null | undefined): string {
  if (!reason) return 'raison inconnue'
  const known = reasonLabels[reason]
  if (known) return known
  const provider = /^PROVIDER_(\d+)$/.exec(reason)?.[1]
  return provider ? `refus du fournisseur (code ${provider})` : reason
}
